// @flow
import React, { PureComponent } from 'react';

import moment from 'moment';
import { formatFullDateString, formatHours } from 'utils/dateUtils';

type Props = {
  forfait: boolean,
  etat: string,
  id: string,
  direct: number,
  dateEffective: Date,
  scoreLocal: string,
  scoreVisiteur: string,
  eligibleFDMD: boolean
};

const liveTest = ['1040264', '1038911', '1031554'];

class RencontreHeaderStatus extends PureComponent<Props> {
  _renderComingSoon = () => {
    const { dateEffective, eligibleFDMD } = this.props;

    return (
      <div>
        <p className="ft-h3 ft-up ft-center mb-0">
          {formatFullDateString(dateEffective)}
          <br />
          {formatHours(dateEffective)}
        </p>
        <span className="label label--long mt-3">
          {eligibleFDMD && (
            <>
              <span className="direct-dot"></span>
              Direct à venir
            </>
          )}
          {!eligibleFDMD && `À venir`}
        </span>
      </div>
    );
  };

  _renderWaiting = () => {
    const { dateEffective } = this.props;

    return (
      <div>
        <p className="ft-h3 ft-up ft-center mb-0">
          {formatFullDateString(dateEffective)}
          <br />
          {formatHours(dateEffective)}
        </p>
        <div className="banner-tooltip mt-1 mb-md-2">
          <i className="icon icon-clock" />
        </div>
        <span className="label label--long mt-3">{`En attente de retours terrain`}</span>
      </div>
    );
  };

  _renderEnded = () => {
    const { scoreLocal, scoreVisiteur } = this.props;

    return (
      <div>
        <div className="banner__scoreboard__score">
          <p className="ft-h2">{scoreLocal}</p>
          <p className="ft-h2">-</p>
          <p className="ft-h2">{scoreVisiteur}</p>
        </div>
        <div className="banner-tooltip mt-1 mb-md-2">
          <div className="tooltip">
            <i className="icon icon-clock" />
            <div className="tooltip__content">
              <span>Score non-validé</span>
              <p>Ce score n’a pas encore été validé par la fédération. Il peut être soumis à des changements</p>
            </div>
          </div>
        </div>
        <span className="label mt-3">Terminé</span>
      </div>
    );
  };

  _renderValidate = () => {
    const { forfait, scoreLocal, scoreVisiteur } = this.props;

    return (
      <div>
        <div className="banner__scoreboard__score">
          <p className="ft-h2">{scoreLocal}</p>
          <p className="ft-h2">-</p>
          <p className="ft-h2">{scoreVisiteur}</p>
        </div>
        <span className="label mt-3">{forfait ? 'Forfait' : 'Terminé'}</span>
      </div>
    );
  };

  _renderPerequation = () => {
    const { etat } = this.props;
    return (
      <div>
        <div className="banner__scoreboard__score"></div>
        <span className="label mt-3">{etat}</span>
      </div>
    );
  };

  _renderDirect = () => {
    const { scoreLocal, scoreVisiteur, direct } = this.props;

    return (
      <div>
        <div className="banner__scoreboard__score">
          <p className="ft-h2">{scoreLocal}</p>
          <p className="ft-h2">-</p>
          <p className="ft-h2">{scoreVisiteur}</p>
        </div>
        <span className="label label--red label--long">
          <span className="direct-dot"></span>
          En direct :&nbsp;
          {direct}
          &apos;
        </span>
      </div>
    );
  };

  render() {
    const { etat, id, dateEffective } = this.props;

    if (liveTest.includes(id) || etat === 'En direct') {
      return this._renderDirect();
    }

    if (etat === 'Planifiée') {
      if (moment().diff(dateEffective, 'hours') >= 25) {
        return this._renderWaiting();
      } else {
        return this._renderComingSoon();
      }
    }

    if (etat === 'Terminée' || etat === 'Présaisie') {
      return this._renderEnded();
    }

    if (etat === 'Score validé') {
      return this._renderValidate();
    }

    if (etat === 'Péréquation' || etat === 'En instance') {
      return this._renderPerequation();
    }

    return null;
  }
}

export default RencontreHeaderStatus;
